import { Controller } from "@hotwired/stimulus"

// Simplified image fallback controller
// Handles image loading errors gracefully without device-specific hacks
export default class extends Controller {
  static targets = ["image", "fallback"]
  static values = { 
    fallbackSrc: String,
    loadingTimeout: { type: Number, default: 10000 } // 10 seconds default
  }
  
  connect() {
    // Disabled - let images load naturally
    // This controller was causing issues on mobile devices
    return
  }
  
  setupImageHandlers() {
    // Disabled - no longer setting up handlers
    return
  }
  
  setLoadingTimeout(img) {
    // Disabled - no timeout needed
    return
  }
  
  handleError(event) {
    const img = event.target
    this.showFallback(img)
  }
  
  handleLoad(event) {
    const img = event.target
    this.hideFallback(img)
  }
  
  showFallback(img) {
    // Hide the failed image
    img.style.display = 'none'
    
    // Find and show fallback element if it exists
    const container = img.closest('[data-image-container]') || img.parentElement
    const fallback = container.querySelector('[data-fallback]')
    
    if (fallback) {
      fallback.style.display = 'flex'
    }
    
    // Add error class for CSS styling
    container.classList.add('image-error')
    
    // If a fallback source is provided, try to load it
    if (this.hasFallbackSrcValue && !img.dataset.fallbackAttempted) {
      img.dataset.fallbackAttempted = 'true'
      img.src = this.fallbackSrcValue
      img.style.display = 'block'
    }
  }
  
  hideFallback(img) {
    const container = img.closest('[data-image-container]') || img.parentElement
    const fallback = container.querySelector('[data-fallback]')
    
    if (fallback) {
      fallback.style.display = 'none'
    }
    
    container.classList.remove('image-error')
    img.style.display = 'block'
  }
  
  // Manual fallback trigger (can be called from templates)
  triggerFallback(event) {
    const img = event.currentTarget
    this.showFallback(img)
  }
  
  isDevelopment() {
    return process.env.NODE_ENV === 'development' || 
           window.location.hostname === 'localhost'
  }
  
  disconnect() {
    // Clean up is handled by event listener options { once: true }
    if (this.isDevelopment()) {
      console.log("Image fallback controller disconnected")
    }
  }
}